export default __webpack_public_path__ + "static/media/logo-altred.9d3c42bf.png";